import React, { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import Navbar from '../navbar/Navbar';

const MainLayout: React.FC = () => {
  const { restaurantId } = useParams<{ restaurantId: string }>();

  useEffect(() => {
    if (restaurantId) {
      const currentStoredId = localStorage.getItem('restaurantId');
      // Update localStorage if URL restaurantId is different
      if (currentStoredId !== restaurantId) {
        localStorage.setItem('restaurantId', restaurantId);
      }
    }
  }, [restaurantId]);

  return (
    <div className="flex flex-col md:flex-row h-screen overflow-hidden">
      <Navbar />
      <main className="flex-1 overflow-auto relative" style={{
        backgroundImage: 'radial-gradient(circle, rgb(0 0 0 / 77%) 0.5px, #000000fc 1px)',
        backgroundSize: '10px 10px'
      }}>
        <div className="relative z-10 px-6 py-2 lg:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
